//IMPORTING COLORS
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { TbBrandLinkedin } from "react-icons/tb";
import LinkedinCallImg from "../../assets/images/linkedin-cta.jpg";
import "./LinkedinCall.css";

export default function LinkedinCall(props) {
  return (
    <Container>
      <Row>
        <Col className="linkedin-call-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <TbBrandLinkedin
              style={{ color: props.iconColor }}
              className="linkedin-call-icon"
            />
            ACOMPANHE NOSSAS VAGAS NO LINKEDIN
          </h2>
        </Col>
      </Row>
      <Row>
        <Col className="linkedin-call-second-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            Siga-nos no LinkedIn e fique por dentro das nossas oportunidades e
            atividades.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <a
            href="https://br.linkedin.com/company/grupokrause"
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-call-link"
          >
            <img
              src={LinkedinCallImg}
              alt="Linkedin Link"
              className="linkedin-call-image"
            />
          </a>
        </Col>
      </Row>
    </Container>
  );
}
